import { useSelector } from 'react-redux';
import { RootState } from 'bootstrap';

export const useLanguageSelectionFeatureEnabled = () => {
  const features = useSelector((state: RootState) => state.app.features);
  return features.find((x) => x === 'TI-226-WEB-LANGUAGE-SELECTION') !== undefined;
};
